import React from 'react';
import { Text, Button } from 'rebass/styled-components';
import PropTypes from 'prop-types';

import { openChat } from '../../../helpers/supportChat';
import { trackEvent } from '../../../helpers/analytics';

const SuggestUs = ({ title, companyId }) => (
  <Text fontSize="12px" marginTop="8px">
    Suggest a {title},{' '}
    <Button
      type="button"
      variant="link"
      fontSize="12px"
      fontWeight="400"
      color="text.main"
      sx={{
        textDecoration: 'underline',
      }}
      p="0"
      onClick={() => {
        openChat();
        trackEvent(`employers:suggest_${title?.split(' ').join('_').toLowerCase()}_click`, {
          companyId,
        });
      }}
    >
      contact us
    </Button>
    .
  </Text>
);

SuggestUs.propTypes = {
  title: PropTypes.string.isRequired,
  companyId: PropTypes.string.isRequired,
};

export default SuggestUs;
